// ALERT
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const WINDOW_RELOAD = 'WINDOW_RELOAD';

// LOADING/SPINNERS
export const SET_LOADING = 'SET_LOADING';
export const SET_SPINNER = 'SET_SPINNER';
export const REMOVE_SPINNER = 'REMOVE_SPINNER';

// AUTH
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const LOGOUT = 'LOGOUT';
export const USER_TOKEN = 'USER_TOKEN';
export const USER_TOKEN_FAIL = 'USER_TOKEN_FAIL';

// BLOG
export const ADD_BLOG = 'ADD_BLOG';
export const REMOVE_BLOG = 'REMOVE_BLOG';
export const GET_BLOG = 'GET_BLOG';
export const BLOG_ERROR = 'BLOG_ERROR';
